<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-document"></i> 版本管理</span>
      </div>

      <!-- 按钮区：独立一行 -->
      <el-row style="margin-bottom: 20px">
        <el-button type="primary" @click="handleAdd"> 更新 </el-button>
      </el-row>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column prop="version" label="当前版本号"></el-table-column>
        <el-table-column prop="url" label="下载地址"></el-table-column>
      </el-table>

      <!-- 添加/编辑弹窗 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="500px"
        @close="handleDialogClose"
      >
        <el-form ref="form" :model="form" :rules="formRules" label-width="80px">
          <el-form-item label="版本号" prop="version">
            <el-input
              v-model.number="form.version"
              placeholder="请输入版本号"
              type="number"
              min="1"
              oninput="if(value.length>10) value=value.slice(0,10)"
            />
          </el-form-item>
          <el-form-item label="APK文件" prop="file">
            <el-upload
              :headers="uploadHeaders"
              :action="UPLOAD_URL"
              :auto-upload="true"
              :on-change="handleFileChange"
              :before-upload="beforeUpload"
              :on-success="handleUploadSuccess"
              :file-list="fileList"
              accept=".apk,application/vnd.android.package-archive"
            >
              <el-button slot="trigger" size="small" type="primary"
                >选取文件</el-button
              >
              <div class="el-upload__tip" slot="tip">
                只能上传apk文件（支持.apk格式），且不超过100MB
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm" :loading="uploadLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { versionNewest, versionUpload } from "@/api/config";
import PaginationBar from "@/components/PaginationBar";
import { UPLOAD_URL } from "@/utils/const";
import { getToken } from "@/utils/auth";

export default {
  name: "LeaveApproval",
  components: { PaginationBar },
  data() {
    return {
      uploadHeaders: {
        token: getToken(), // 替换为你的 token
      },
      UPLOAD_URL,
      isEdit: false, // 是否为编辑状态
      form: {
        version: "",
      },
      formRules: {
        version: [
          { required: true, message: "请输入版本号", trigger: "blur" },
          { type: "number", message: "版本号必须为数字", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value && !Number.isInteger(value)) {
                callback(new Error("版本号必须为整数"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value && value <= 0) {
                callback(new Error("版本号必须大于0"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      dialogVisible: false,
      dialogTitle: "版本更新",
      uploadedFileUrl: "", //上传地址
      selectedRows: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      // 查询参数
      queryParams: {
        name: "",
      },
      // 表格数据
      tableData: [],
      fileList: [],
      uploadFile: null,
      uploadLoading: false,
    };
  },
  created() {
    this.handleQuery(1);
  },
  methods: {
    // 添加上传成功事件处理函数
    handleUploadSuccess(response, options) {
      // 存储上传成功返回的文件地址
      if (response.data) {
        this.uploadedFileUrl = response.data;
        this.$message.success(`上传成功`);

        // 可以在这里触发其他业务逻辑
        console.log("文件上传成功，返回地址:", this.uploadedFileUrl);
      }
    },
    beforeUpload(file) {
      // 检查文件是否为APK类型（支持.apk以及.apk.*格式）
      const isAPK =
        file.type === "application/vnd.android.package-archive" ||
        file.name.toLowerCase().endsWith(".apk") ||
        /\.apk(\.\d+)+$/i.test(file.name);

      const isLt100M = file.size / 1024 / 1024 < 100;

      if (!isAPK) {
        this.$message.error("只能上传 APK 格式的文件!");
      }
      if (!isLt100M) {
        this.$message.error("上传文件大小不能超过 100MB!");
      }

      return isAPK && isLt100M;
    },
    customUpload(options) {
      // 自定义上传请求，这里可以留空或者根据实际需求实现
      // 因为我们使用的是 submitForm 中的 versionUpload 方法来上传
      console.log("Custom upload triggered", options);
    },
    handleAdd() {
      this.dialogVisible = true;
      this.isEdit = false;
      this.dialogTitle = "版本更新";
      this.form = {
        version: "",
      };
      this.fileList = [];
      this.uploadFile = null;
    },
    handleFileChange(file, fileList) {
      this.uploadFile = file.raw;
      this.fileList = [file];

      // 文件选择后手动清除验证错误信息
      this.$nextTick(() => {
        this.$refs.form.clearValidate("file");
      });
    },
    submitForm() {
      // 验证版本号
      this.$refs.form.validateField("version", (valid) => {
        // 检查版本号是否为空
        if (valid) {
          return;
        }

        // 检查文件是否已选择
        if (!this.uploadedFileUrl) {
          this.$message.error("请上传APK文件");
          return;
        }

        this.uploadLoading = true;

        versionUpload({
          version: this.form.version,
          url: this.uploadedFileUrl,
        })
          .then((response) => {
            this.$message.success("版本更新成功");
            this.dialogVisible = false;
            this.handleQuery();
          })
          .catch((error) => {
            this.$message.error(
              "版本更新失败: " + (error.message || "未知错误")
            );
          })
          .finally(() => {
            this.uploadLoading = false;
          });
      });
    },
    handleQuery() {
      versionNewest().then((res) => {
        this.tableData = [res];
      });
    },
    handleDialogClose() {
      this.$refs.form.resetFields();
      this.fileList = [];
      this.uploadFile = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  .el-icon-document {
    margin-right: 5px;
    font-size: 18px;
  }

  .el-table {
    .el-icon-user,
    .el-icon-office-building,
    .el-icon-document,
    .el-icon-time,
    .el-icon-date,
    .el-icon-notebook-2 {
      margin-right: 5px;
    }
  }

  .el-tag {
    .el-icon-check,
    .el-icon-loading,
    .el-icon-close {
      margin-right: 5px;
    }
  }

  .el-button {
    .el-icon-edit,
    .el-icon-delete,
    .el-icon-plus,
    .el-icon-close,
    .el-icon-check {
      margin-right: 5px;
    }
  }

  .el-select {
    .el-icon-document,
    .el-icon-first-aid-kit,
    .el-icon-date,
    .el-icon-time {
      margin-right: 5px;
    }
  }

  .demo-form-inline {
    .el-form-item {
      margin-bottom: 10px;
    }
  }

  .search-buttons {
    margin-bottom: 20px;

    .el-button {
      margin: 0 10px;
    }
  }
}
.el-table__content {
  overflow-x: auto;
}
.el-table {
  &__header-wrapper {
    th {
      background-color: #f5f7fa !important;
      color: #333;
      font-weight: bold;
    }
  }

  &--border,
  &--group {
    border: 1px solid #dcdfe6;
  }

  .cell {
    white-space: nowrap;
  }
}
</style>
